"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetModals = exports.closeModal = exports.Confirm = exports.Save = exports.OkCancel = exports.Ok = exports.CancelConfirm = exports.YesNoCancel = exports.YesNo = exports.showModal = void 0;

var constants = _interopRequireWildcard(require("./constants"));

var showModal = function showModal(type, props) {
  return {
    type: constants.SHOW_MODAL,
    payload: {
      type: type,
      props: props
    }
  };
};

exports.showModal = showModal;

var YesNo = function YesNo(props) {
  return {
    type: constants.SHOW_MODAL,
    payload: {
      type: constants.YES_NO,
      props: props
    }
  };
};

exports.YesNo = YesNo;

var YesNoCancel = function YesNoCancel(props) {
  return {
    type: constants.SHOW_MODAL,
    payload: {
      type: constants.YES_NO_CANCEL,
      props: props
    }
  };
};

exports.YesNoCancel = YesNoCancel;

var CancelConfirm = function CancelConfirm(props) {
  return {
    type: constants.SHOW_MODAL,
    payload: {
      type: constants.CANCEL_CONFIRM,
      props: props
    }
  };
};

exports.CancelConfirm = CancelConfirm;

var Ok = function Ok(props) {
  return {
    type: constants.SHOW_MODAL,
    payload: {
      type: constants.OK,
      props: props
    }
  };
};

exports.Ok = Ok;

var OkCancel = function OkCancel(props) {
  return {
    type: constants.SHOW_MODAL,
    payload: {
      type: constants.OK_CANCEL,
      props: props
    }
  };
};

exports.OkCancel = OkCancel;

var Save = function Save(props) {
  return {
    type: constants.SHOW_MODAL,
    payload: {
      type: constants.SAVE,
      props: props
    }
  };
};

exports.Save = Save;

var Confirm = function Confirm(props) {
  return {
    type: constants.SHOW_MODAL,
    payload: {
      type: constants.CONFIRM,
      props: props
    }
  };
};

exports.Confirm = Confirm;

var closeModal = function closeModal(modalKey) {
  return {
    type: constants.HIDE_MODAL,
    modalKey: modalKey
  };
};

exports.closeModal = closeModal;

var resetModals = function resetModals() {
  return {
    type: constants.RESET_MODALS
  };
};

exports.resetModals = resetModals;